//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import SearchTaskItem from '@/components/tasks/SearchTaskItem'
import SearchHeading from '@/components/search/SearchHeading'

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'TasksSearch',
  components: {
    SearchTaskItem,
    SearchHeading
  },
  data () {
    return {
      loading: false,
      page: 1
    }
  },
  async fetch () {
    this.page = this.$route.query.page || 1

    if (this.$route.params.skillId) {
      const skillId = parseInt(this.$route.params.skillId, 10)
      const selectedSkill = this.$store.getters['util/getAllSkillsMappings'][skillId]
      this.$store.commit('search/setCategory', selectedSkill?.categoryId)
      this.$store.commit('search/setSkill', skillId)
    }

    await this.runSearch()
  },
  computed: {
    ...mapState('search', {
      tasks: 'tasks',
      total: 'total'
    }),
    language () {
      return this.$store.state.i18n.locale
    },
    numberOfPages () {
      return this.$store.getters['search/numberOfPages']
    }
  },
  methods: {
    linkGen (pageNum) {
      return `?page=${pageNum}`
    },
    async changePage (e) {
      this.page = e
      await this.runSearch()
      if (process.browser) {
        window.scrollTo(0, 0)
      }
    },
    async filter () {
      this.page = 1
      await this.runSearch()
    },
    async runSearch () {
      try {
        this.loading = true
        await this.$store.dispatch('search/runSearch', this.page)
        this.loading = false
      } catch (err) {
        this.loading = false
        await this.$store.dispatch('ui/showNotification', {
          text: this.$t('common.error'),
          type: 'danger'
        })
      }
    }
  }
}
